import { useEffect } from 'react';
import { useAppSettingsStore } from '@/shared/lib';
import { useDictionary } from './useDictionary';
import type { Country } from '@/shared/types';

const useCountriesDictionary = () => {
  const { language } = useAppSettingsStore();

  const {
    data: countriesData,
    isLoading: isCountriesLoading,
    error: countriesError,
    refetch: refetchCountries,
  } = useDictionary<Country[]>({
    dictionaryName: 'countries',
  });

  useEffect(() => {
    refetchCountries();
  }, [language]);

  return {
    countriesData,
    isCountriesLoading,
    countriesError,
  };
};

export { useCountriesDictionary };
